<template>
    <div>
        <v-card elevation="0">
            <v-card color="#CE93D8" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-bank-outline</v-icon>
                    &nbsp;Academic Department Manager
                </v-card-title>
            </v-card>
            <v-card-text>
                <Department />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import Department from "../../../components/Admin/AcademicDepartment/Manager.vue"
export default {
    components: {
        Department
    }
}
</script>